import React from 'react'
import { Link } from 'react-router-dom'
import { Button } from 'semantic-ui-react'
import styled from 'styled-components'
import { endRegisterRace, formatDateTime } from '../../utils/index'

const StyledCard = styled.div.attrs({
  className: 'ui centered card'
})`
  && {
    width: 90%;
    margin-bottom: 15px;
  }
`

export const RaceCard = ({ race }) => (
  <React.Fragment>
    <StyledCard>
      <div className="ui image">
        <img src={race.feature_image} />
      </div>
      <div className="content">
        <div>
          <h1 className="mobile-h1">{race.title}</h1>
          <p>
            <span style={{ fontWeight: 'bold' }}>ประเภทของกิจกรรม</span>:{' '}
            {race.is_walk
              ? 'เดินเก็บระยะก้าว'
              : race.collect_distance
              ? 'วิ่งแบบสะสมระยะ'
              : 'วิ่งแบบครั้งเดียวจบ'}
          </p>
          <p>
            <span style={{ fontWeight: 'bold' }}>วันเปิดรับสมัคร</span>:{' '}
            {formatDateTime(race.start_register_time)} -{' '}
            {formatDateTime(race.end_register_time)} (หรือจนกว่าจะเต็มจำนวน)
          </p>

          <p>
            <span style={{ marginTop: '5', fontWeight: 'bold' }}>
              วันแข่งขัน:{' '}
            </span>
            {formatDateTime(race.start_time)} - {formatDateTime(race.end_time)}
          </p>
          <p>
            <span style={{ marginTop: '5', fontWeight: 'bold' }}>
              วันส่งผลการแข่งขัน:{' '}
            </span>
            {formatDateTime(race.start_time)} -{' '}
            {formatDateTime(race.last_submit_time)}
          </p>
          <p>
            <span style={{ marginTop: '5', fontWeight: 'bold' }}>
              วันสิ้นสุดกิจกรรม:{' '}
            </span>
            {formatDateTime(race.last_submit_time)}
          </p>
          <p>
            <span style={{ marginTop: '5', fontWeight: 'bold' }}>
              ช่วงเวลาจัดส่งของที่ระลึก:{' '}
            </span>
            ภายใน 10 วันทำการ หลังสิ้นสุดกิจกรรม
          </p>
        </div>
        {endRegisterRace(race) ? (
          <Button
            color="red"
            className="no-hover"
            fluid
            style={{ marginTop: '10px' }}
          >
            ปิดรับสมัคร
          </Button>
        ) : (
          <Link to={`/races/${race.slug}`}>
            <Button color="teal" fluid style={{ marginTop: '10px' }}>
              สมัคร
            </Button>
          </Link>
        )}
      </div>
    </StyledCard>
  </React.Fragment>
)



// WEBPACK FOOTER //
// /opt/build/repo/src/components/RaceCard/index.js